export const PDF_EDITABLE_STATUS = [
    {value: 'INITIAL', name: 'Initial'},
    {value: 'RETRIVING_DATA', name: 'Retrieving data'},
    {value: 'DATA_RETRIVED', name: 'Data retrieved'},
    {value: 'CANCELED', name: 'Canceled'},
    // {value: 'DOC_DEPLOYED', name: 'Document deployed'},
    // {value: "FILLED", name: "Document filled"},
    // {value: "CONTACTED", name: "Sent"}
]